import axios from 'axios'
import ApiService from './ApiService'
import { ContentPrefixes } from 'lib/constants/ContentPrefixes'

const FileUploadService = {
    upload(file: Blob, contentPrefix: ContentPrefixes, generateCode?: boolean) {
        const formatData = new FormData()
        formatData.append('file', file)
        return ApiService.post(
            `/file-upload?contentPrefix=${contentPrefix}${generateCode ? '&generateCode=true' : ''}`,
            formatData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        ).then((response) => {
            return {
                filename: response.data.filename as string,
                contentPrefix: response.data.contentPrefix as string,
                url: response.data.URL as string,
                code: response.data.code as string,
            }
        })
    },

    getCloudflareVideoUploadUrl() {
        return ApiService.get('/knows/upload-video-url').then((response) => {
            return {
                uploadUrl: response.data.uploadUrl as string,
                uid: response.data.uid as string,
            }
        })
    },

    uploadCloudFlareVideo(url: string, file: Blob) {
        const formatData = new FormData()
        formatData.append('file', file)
        return axios
            .post(`${url}`, formatData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                return response
            })
    },
}

export default FileUploadService
